<template>
  <div class="container-page-data">
    <div class="container-table-data">
      <div v-for="(item, index) in filteredTypo('residentialData')" :key="'resi_' + item.id" class="table-data" :class="'table-data-' + (index + 1)">
        <dataListEvolVar
          :id="'resi_' + item.id"
          :id-data="'resi_' + item.id"
          :title="getParsedName(item.id, 'residential')"
          :qoq-title="$t('qoq-var')"
          :yoy-title="$t('yoy-var')"
          :data="item.data"
          :tooltips-active="false"
          :export-val="true"
          class="mt-2"
        />
      </div>
      <div v-for="(item, index) in filteredGeneric" :key="'generic_' + item.id" class="table-data" :class="'table-data-' + (index + 1)">
        <dataListEvolVar
          :id="'generic_' + item.id"
          :id-data="'generic_' + item.id"
          :title="$t(item.id)"
          :qoq-title="$t('qoq-var')"
          :yoy-title="$t('yoy-var')"
          :data="item.data"
          :tooltips-active="false"
          :export-val="true"
          class="mt-2"
        />
      </div>
    </div>
  </div>
</template>

<script>
import dataListEvolVar from '@/components/designComponents/dataListEvolVar'
import { _ } from 'vue-underscore'

export default {
  name: 'PageData',
  components: { dataListEvolVar },
  props: {
    data: {
      default: null
    }
  },
  data() {
    return {
      allData: []
    }
  },
  computed: {
    filteredGeneric: {
      get() {
        if (this.data) {
          var res = []
          var group = _.groupBy(this.data.genericData, 'bloque')
          for (var [key, value] of Object.entries(group)) {
            if (value) {
              res.push({
                id: this.parsedGroupGeneric(parseInt(key)),
                data: value.filter((f) => !!f.dato)
              })
            }
          }
          return res
        }
        return []
      }
    }
  },
  methods: {
    filteredTypo(typo) {
      if (this.data) {
        var res = []
        var group = _.groupBy(this.data[typo], 'bloque')
        for (var [key, value] of Object.entries(group)) {
          if (value) {
            res.push({
              id: this.parsedGroup(parseInt(key)),
              data: value
            })
          }
        }
        return res
      }
      return []
    },
    parsedGroup(group) {
      switch (group) {
        case 1:
          return 'sale_market'
        case 2:
          return 'sale_trans'
        case 3:
          return 'rent_market'
        case 4:
          return 'net_rent'
        case 5:
          return 'rent_declared'
        case 6:
          return 'brokers'
        case 7:
          return 'brains_index'
        default:
          return null
      }
    },
    parsedGroupGeneric(group) {
      switch (group) {
        case 1:
          return 'risk_index'
        case 2:
          return 'socioeconomics_index'
        case 3:
          return 'population'
        case 4:
          return 'economy'
        case 5:
          return 'monthly_unemployment'
        case 6:
          return 'annual_unemployment'
        case 7:
          return 'dwellings'
        default:
          return null
      }
    },
    getParsedName(itemName, typo) {
      return this.$t('dataSection.' + itemName) + (' <span class="data-sidebar-typo-light-v2">(' + this.$t(typo) + ')</span>')
    }
  }
}
</script>

<style lang="scss" scoped>
.container-page-data {
  width: 100%;
  height: 100%;

  .container-table-data {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    flex-direction: column;
    align-items: center;

    // display: grid;
    // grid-template-columns: 1fr 1fr 1fr;
    // grid-template-rows: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;

    // grid-template-areas:
    // "saleMarket population economy"
    // "rentMarket population economy"
    // "rentMarket dwelling economy"
    // ". dwelling ."
    // ". dwelling ."
    // ". brokers ."
    // ". brokers .";

    // gap: 20px;

    // .table-data {
    //   // width: 30%;
    //   display: inline-flex;

    //   .brains-data-list-container {
    //     margin-top: 0 !important;
    //   }

    //   &-1 {
    //     grid-area: saleMarket;
    //   }

    //   &-2 {
    //     grid-area: rentMarket;
    //   }

    //   &-3 {
    //     grid-area: dwelling;
    //     margin-top: 15px;
    //   }

    //   &-4 {
    //     grid-area: brokers;
    //   }

    //   &-5 {
    //     grid-area: population;
    //   }

    //   &-6 {
    //     grid-area: economy;
    //   }
    // }
  }
}
</style>

<style lang="scss">
.table-data {
  width: 33%;

  .brains-data-list-container {
    margin-top: 0 !important;

    .brains-data-list--content div .row {
      padding: 2px !important;
    }
  }
}
</style>
